
import { Options, Vue } from 'vue-class-component';
import EntropyFromMouse from '@/components/EntropyFromMouse.vue';
import Drawer from '@/components/Drawer.vue';
import HorcruxPrint from '@/components/HorcruxPrint.vue';
import HorcruxVault from '@/components/HorcruxVault.vue';
import Qr from '@/components/Qr.vue';
import { $wallet, i18n } from '../services';
import * as secret from 'secrets.js-34r7h';
import { I_MouseEntropyResult } from '@/lib/MouseEntropyEngine';

@Options({
  components: {
    EntropyFromMouse, 
    Drawer, 
    Qr,
    HorcruxPrint,
    HorcruxVault
  },
})
export default class Home extends Vue {
  private _currentHorcrux = '';

  drawer: any = {
    vault: false,
    print: false
  }

  mnemonicLength:any = {
    12:{value:16,selected:true,label:"12-word: Argent, Coinbase Wallet, Mycelium, Electrum, Ledger, Metamask, Trezor"},
    //15:{value:20,selected:false,label:""},
    18:{value:24,selected:false,label:"18-word: Ledger"},
    //21:{value:28,selected:false,label:""},
    //24:{value:32,selected:false,label:"24-word: Trezor One, Ledger"}
  };
  mnemonicBytes = 16;


  entropyStart = false;
  mnemonic = "";
  seed = "";
  shares: secret.Shares = [];

  //
  // helpers for typescript
  $refs!: {
    entropyGen: EntropyFromMouse,
    textarea: HTMLInputElement
  }  



  async mounted() {
    this.entropyStart = false;
    if(!$wallet.entropy || !$wallet.entropy.length) {
      return;
    }
    this.mnemonic = await $wallet.createMnemonic($wallet.entropy,this.mnemonicBytes);
    this.seed = (await $wallet.getSeed(this.mnemonic));
    this.shares = await $wallet.getShamirCache();

  }

  get combineShares() {
    if(!this.shares.length) {
      return ''
    }    
    return secret.combine(this.shares);
  }

  get currentHorcrux() {
    if(!this._currentHorcrux) {
      return {};
    }
    return {
      version:this._currentHorcrux.substring(0,3),
      share:this._currentHorcrux,
      base64:($wallet.b64.encode('0x'+this._currentHorcrux+'0'))
    };
  }

  get isInvalidMnemonic() {
    if(!this.mnemonic || this.mnemonic == '') {
      return true;
    }
    return !$wallet.isValidMnemonic(this.mnemonic);
  }

  async onChange($event: any) {
    this.mnemonicBytes = this.mnemonicLength[$event.target.value].value;
    this.mnemonic = await $wallet.createMnemonic($wallet.entropy,this.mnemonicBytes);
    this.seed = (await $wallet.getSeed(this.mnemonic));
    this.shares = await $wallet.createShamirSecretFromSeed();


  }

  async onEntropyCollected(entropyResult: I_MouseEntropyResult){
    console.log("entropy collected", entropyResult.bytes);
    this.entropyStart = false;

    $wallet.entropy = entropyResult.bytes;
    this.mnemonic = await $wallet.createMnemonic($wallet.entropy,this.mnemonicBytes);
    this.seed = (await $wallet.getSeed(this.mnemonic));
    this.shares = await $wallet.createShamirSecretFromSeed();

    //
    // FOR demon only
    $wallet.memoryMnemonic = this.mnemonic;

  }

  async onI18n(ln:i18n) {
    $wallet.setDefaultLang(ln,this.mnemonicBytes);
    this.mnemonic = await $wallet.createMnemonic($wallet.entropy,this.mnemonicBytes);
  }

  onEntropyStart(){
    this.entropyStart = true;
  }

  async onRetrieve(){
    if(!$wallet.entropy.length) {
      $wallet.entropy = $wallet.retrieveEntropy(this.mnemonic);
    }
    this.seed = (await $wallet.getSeed(this.mnemonic));
    this.shares = await $wallet.createShamirSecretFromSeed();
  }

  onFocus() {
    if(!this.mnemonic){
      return;
    }
    this.$refs.textarea.select();
    this.$refs.textarea.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    //navigator.clipboard.writeText(this.mnemonic);

  }

  onHorcrux(share: string, destination:string) {
    this._currentHorcrux = share;
    this.drawer[destination] = !this.drawer[destination];
  }

  onStart() {
    this.$refs.entropyGen.start();
  }
}
